import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import Detail from './detail';
import FileUpload from './fileUpload';
import FileInfo from './fileInfo';
import ProcessButton from './processButton';
import FileDownload from './fileDownload';
import './stock.scss';

class StockOrder extends Component {
  constructor(props) {
    super(props);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.DealerStockOrders, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.clearStockOrder();
  }

  handleClearClick() {
    this.props.clearStockOrder();
  }

  renderButtons() {
    if (!this.props.verified) {
      return (<FileUpload />);
    }

    return (
      <React.Fragment>
        <Button secondary
          onClick={this.handleClearClick}
          content='LIMPIAR'
          disabled={this.props.loading}
        />
        <ProcessButton />
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className='dealer-stock-orders'>
        <Card raised fluid className='order-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='8' textAlign='left'>
                <h2>Pedidos de Stock</h2>
              </Grid.Column>
              <Grid.Column width='8' textAlign='right'>
                {this.renderButtons()}
                <FileDownload />
              </Grid.Column>
            </Grid.Row>
            <FileInfo />
          </Grid>
        </Card>
        <Detail />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'verified': state.dealerStockOrders.verified,
    'loading': state.dealerStockOrders.loading,
  };
};

const {
  loadStockOrderFile,
  clearStockOrder,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  loadStockOrderFile,
  clearStockOrder,
  navigateTo,
})(StockOrder);
